<div class="modal-header">
  <h5 class="modal-title">Scan Details</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div *ngIf="loading" class="text-center text-muted p-3">
    <span class="spinner-border spinner-border-sm"></span> Loading...
  </div>

  <table class="table table-sm mb-0" *ngIf="redeemRequest">
    <tbody>
      <tr>
        <th style="width: 40%;">Customer Name</th>
        <td>{{ customerName }}</td>
      </tr>
      <tr>
        <th>Mobile Number</th>
        <td>{{ mobile || '—' }}</td>
      </tr>
      <tr>
        <th>QR Code</th>
        <td><strong>{{ redeemRequest.qrCode }}</strong></td>
      </tr>
      <tr>
        <th>Product</th>
        <td>{{ redeemRequest.product?.name }}</td>
      </tr>
      <tr>
        <th>Amount</th>
        <td>{{ redeemRequest.product?.commission }}</td>
      </tr>
      <tr>
        <th>Status</th>
        <td>{{ redeemRequest.requestStatus === 'Open' ? 'Unpaid' : redeemRequest.requestStatus }}</td>
      </tr>
      <tr>
        <th>Other scans by this customer</th>
        <td>{{ loading ? '…' : otherScanCount }}</td>
      </tr>
    </tbody>
  </table>

  <div class="alert alert-info mt-2 mb-0 py-2" *ngIf="!loading && !canDeleteCustomer && redeemRequest?.customer">
    This customer has previous scans, so they can't be deleted — only the QR code will be re-enabled.
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()" [disabled]="working">
    Close window
  </button>
  <button type="button" class="btn btn-danger" (click)="reEnable()" [disabled]="loading || working">
    {{ working ? 'Working…' : 'Re-enable QR Code' }}
  </button>
</div>
